"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promisifyTimeout = void 0;
var promisifyTimeout = function (timeoutMs, errorMessage) {
    var timeout;
    var promise = function () {
        return new Promise(function (resolve) {
            timeout = setTimeout(function () {
                resolve(new Error(errorMessage));
            }, timeoutMs);
        });
    };
    var clear = function () {
        clearTimeout(timeout);
    };
    return { promise: promise, clear: clear };
};
exports.promisifyTimeout = promisifyTimeout;
//# sourceMappingURL=generic.js.map